import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "JE_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#JE_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v24H0V0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.702 1.245L-4.75.006V24.794l2.048-1.238 16.538-10 1.91-1.156-1.91-1.155-16.538-10z",
      fill: "#F7FCFF",
      stroke: "#E31D1C",
      strokeWidth: 2.7
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M34.92 1.233L36.948.055v24.691l-2.028-1.178-17.22-10-2.01-1.168 2.01-1.167 17.22-10z",
      fill: "#F7FCFF",
      stroke: "#E31D1C",
      strokeWidth: 2.7
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.675 4.703S12.817 8.5 15.781 9.96c0 0 2.847-1.551 2.207-5.257 0 0-1.222-.41-2.194-.41s-2.119.41-2.119.41z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.982 5.498s.317-.14.474 0c.157.14.286-.012.286-.096 0-.085.249-.376.249-.14s-.078.37.141.37c.22 0 1.206-.327 1.443-.23.236.096.417.072.357-.066s-.215-.225-.512-.15c-.298.076-.228.15-.485.15s-.543-.074-.543-.074.08-.124.374-.036c.293.089.698-.109.809-.109.11 0 .413-.006.443.07.03.075.213.144.073.215-.14.07-.37.114-.21.204.157.09.521.073.539.167.018.093.19.233.12.233-.068 0-.194.132-.31.092-.117-.04-.13-.075-.018-.108.111-.032.11-.17.018-.17s-.047.049-.257 0c-.21-.047-.488-.1-.47 0 .016.102.152.257-.1.278-.252.02-.37.104-.419.037-.049-.067-.224-.156-.086-.185.138-.028.27.097.319.077.05-.02.162-.032.068-.12-.094-.086-.25-.138-.106-.203.145-.065.03-.066-.244.069s-.427.25-.668.233c-.241-.016-.332.006-.409-.016-.078-.022-.455.242-.564.175-.108-.067-.459-.093-.396-.175.063-.082.148-.125.242-.082.095.042.189.085.252.042.064-.042.248-.188.202-.217-.046-.029-.002-.127-.264-.127-.261 0-.354.11-.416.04-.062-.068.068-.148.068-.148zM14.245 6.746s.278-.123.416 0c.138.123.251-.01.251-.085 0-.074.22-.33.22-.122 0 .207-.069.324.124.324.192 0 1.06-.286 1.268-.202.208.085.367.064.314-.058-.053-.121-.189-.197-.45-.13-.262.066-.2.13-.427.13-.226 0-.477-.064-.477-.064s.07-.11.329-.032c.258.078.614-.096.71-.096.098 0 .364-.005.39.061.027.067.188.128.065.19-.123.061-.325.1-.186.18.14.078.46.063.475.145.015.083.167.206.106.206-.06 0-.17.116-.273.08-.103-.035-.115-.066-.016-.094.098-.03.097-.15.016-.15s-.042.043-.226 0c-.185-.042-.429-.088-.414 0 .015.09.135.226-.087.245-.222.018-.325.09-.368.032-.043-.059-.198-.137-.076-.163.12-.025.237.086.28.068.044-.018.143-.028.06-.105-.083-.076-.22-.122-.093-.179.127-.057.027-.058-.214.06-.242.12-.376.22-.588.206-.212-.014-.291.005-.36-.014-.068-.02-.4.212-.495.153-.095-.058-.404-.081-.348-.153.055-.073.13-.11.213-.073.083.037.165.075.221.037.056-.037.218-.165.177-.19-.04-.026-.001-.112-.231-.112s-.312.096-.366.036c-.055-.06.06-.131.06-.131zM14.616 8.014s.211-.094.316 0c.104.093.19-.008.19-.065 0-.056.166-.25.166-.093 0 .158-.052.246.095.246.146 0 .803-.217.961-.153.158.065.278.049.238-.043-.04-.093-.143-.15-.341-.1-.199.05-.152.1-.323.1-.172 0-.363-.05-.363-.05s.054-.082.25-.023c.195.058.465-.073.539-.073.073 0 .275-.004.296.046.02.05.142.097.049.143-.093.047-.247.077-.141.137.105.06.348.048.36.11.011.063.126.157.08.157s-.13.088-.207.06c-.078-.026-.087-.05-.012-.071.074-.022.073-.113.012-.113s-.031.032-.171 0-.325-.068-.314 0c.01.067.102.17-.066.185-.168.014-.247.069-.28.024-.032-.044-.15-.104-.057-.123.092-.019.18.065.213.051.033-.013.108-.021.045-.08-.063-.057-.167-.091-.07-.135.096-.043.02-.044-.163.046s-.285.166-.446.156c-.16-.011-.22.003-.272-.011-.052-.015-.304.161-.376.116-.072-.044-.306-.061-.264-.116.042-.055.098-.083.161-.055.063.028.126.056.168.028.043-.028.165-.125.135-.145-.031-.019-.001-.084-.176-.084s-.236.073-.278.027c-.041-.046.046-.1.046-.1z",
      fill: "#FFD100"
    }
  ), /* @__PURE__ */ e.createElement("g", { filter: "url(#JE_svg__filter0_d_4799_265896)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.906 3.014c.413.226.722 1.724.722 1.724s1.212-.422 2.166-.422c.953 0 2.166.422 2.166.422s.309-1.498.721-1.724c.149-.082.126-.071.025-.024-.18.085-.605.285-.746.285-.094 0-.139.12-.19.257-.068.185-.148.4-.376.4a.51.51 0 01-.432-.197c.117-.038.2-.135.2-.249 0-.146-.137-.264-.307-.264-.17 0-.307.118-.307.264 0 .094.057.177.143.224a1.073 1.073 0 01-.34.063c-.28 0-.404-.16-.404-.41 0-.25.545-.35.545-.35s0-.456-.545-.228c0 0 .107-.523-.152-.783V2h-.002v.002c-.26.26-.152.783-.152.783-.545-.228-.545.229-.545.229s.545.1.545.35c0 .25-.124.409-.404.409-.123 0-.243-.03-.34-.063a.258.258 0 00.142-.224c0-.146-.137-.264-.306-.264-.17 0-.307.118-.307.264 0 .114.083.211.2.249a.51.51 0 01-.432.198c-.228 0-.308-.216-.377-.401-.05-.137-.095-.257-.19-.257-.14 0-.566-.2-.745-.285-.1-.047-.124-.058.024.024z",
      fill: "#FECA00"
    }
  ))),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
    "filter",
    {
      id: "JE_svg__filter0_d_4799_265896",
      x: 12.801,
      y: 2,
      width: 5.986,
      height: 2.737,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB"
    },
    /* @__PURE__ */ e.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
    /* @__PURE__ */ e.createElement(
      "feColorMatrix",
      {
        in: "SourceAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }
    ),
    /* @__PURE__ */ e.createElement("feOffset", null),
    /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0.0313726 0 0 0 0 0.368627 0 0 0 0 0 0 0 0 0.28 0" }),
    /* @__PURE__ */ e.createElement(
      "feBlend",
      {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4799_265896"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "feBlend",
      {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_4799_265896",
        result: "shape"
      }
    )
  ))
), c = t;
export {
  c as default
};
